import React from 'react'
import { useTranslation } from 'react-i18next'

import toolkitLogo from '@assets/images/toolkit-logo-light.png'

import { BottomSheet } from '@components/BottomSheet/BottomSheet.component'

import {
  Footer,
  ImgLogo,
  UpdateButton,
  UpdateContainer,
  UpdateDescription,
  UpdateTitle,
  LogoContainer,
  BodyContainer,
} from './BottomSheetCheckUpdate.styled'

interface BottomSheetCheckUpdateProps {
  open: boolean
  onDismiss: () => void
  onUpdate: () => void
}

export const BottomSheetCheckUpdate: React.FC<BottomSheetCheckUpdateProps> = ({ open, onDismiss, onUpdate }) => {
  const { t } = useTranslation()

  const handleUpdate = (): void => {
    onUpdate()
  }

  return (
    <BottomSheet
      open={open}
      onDismiss={onDismiss}
      minHeight="300px"
      snapPoints={({ maxHeight }: { maxHeight: number }) => [Math.min(350, maxHeight * 0.8)]}
    >
      <UpdateContainer>
        <LogoContainer>
          <ImgLogo src={toolkitLogo} />
        </LogoContainer>

        <BodyContainer>
          <UpdateTitle>{t('modules_main_components_BottomSheetCheckUpdate_title')}</UpdateTitle>

          <UpdateDescription>{t('modules_main_components_BottomSheetCheckUpdate_desc')}</UpdateDescription>
        </BodyContainer>

        <Footer>
          <UpdateButton onClick={handleUpdate} type="button">
            {t('modules_main_components_BottomSheetCheckUpdate_button_label')}
          </UpdateButton>
        </Footer>
      </UpdateContainer>
    </BottomSheet>
  )
}
